import { resolveProgramFundingMeta, resolveTransactionFundingMeta } from './penyaluranFundingMap';

export function resolveDonationAmount(item) {
  return Number(item?.jumlah || item?.jumlah_donasi || item?.nominal || 0) || 0;
}

export function resolveDonationStatus(item) {
  return String(item?.status || item?.status_transaksi || item?.statusTransaksi || '')
    .trim()
    .toLowerCase();
}

export function isSuccessfulDonation(item) {
  return ['success', 'verified', 'diverifikasi', 'berhasil', 'sukses', 'paid', 'settlement'].includes(resolveDonationStatus(item));
}

export function normalizeBalanceKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function normalizeFundingType(value) {
  const normalized = normalizeBalanceKey(value).replace(/[\s-]+/g, '_');
  if (normalized.includes('amil')) return 'dana_amil';
  if (normalized.includes('zakat')) return 'zakat';
  if (normalized.includes('infak') || normalized.includes('infaq') || normalized.includes('sedekah')) return 'infak';
  if (normalized.includes('wakaf')) return 'wakaf';
  return normalized;
}

export function resolveStoredFundingType(item) {
  return normalizeFundingType(
    item?.sumber_dana ||
    item?.sourceType ||
    item?.source_type ||
    item?.kategori_dana ||
    item?.jenis_sumber_dana ||
    ''
  );
}

export function resolveDetailDonationMeta(item, detailDonasiList = []) {
  const code = String(
    item?.kode_detail_donasi ||
    item?.kodeDetailDonasi ||
    item?.detail_donasi?.kode_detail_donasi ||
    item?.detail_donasi?.kode ||
    item?.detailDonasi?.kode_detail_donasi ||
    item?.detailDonasi?.kode ||
    ''
  ).trim();

  const name =
    item?.detail_donasi?.nama_detail_donasi ||
    item?.detail_donasi?.nama ||
    item?.detailDonasi?.nama_detail_donasi ||
    item?.detailDonasi?.nama ||
    item?.nama_detail_donasi ||
    '';

  const matchedDetail = detailDonasiList.find((detail) => {
    const detailCode = String(
      detail?.kode_detail_donasi ||
      detail?.kodeDetailDonasi ||
      detail?.kode ||
      detail?.id_detail_donasi ||
      detail?.id ||
      ''
    ).trim();

    return code && detailCode === code;
  });

  return {
    code,
    name: name || matchedDetail?.nama_detail_donasi || matchedDetail?.nama || '',
  };
}

export function resolveTransactionFundingType(item, detailDonasiList = [], jenisName = '') {
  const storedType = resolveStoredFundingType(item);
  if (storedType) return storedType;

  const detailMeta = resolveDetailDonationMeta(item, detailDonasiList);
  const fundingMeta = resolveTransactionFundingMeta(item, detailMeta);
  if (fundingMeta.sourceType) return fundingMeta.sourceType;

  const normalizedJenis = normalizeFundingType(jenisName);
  if (normalizedJenis === 'zakat') return 'zakat';
  if (normalizedJenis === 'infak') return 'infak';
  if (normalizedJenis === 'wakaf') return 'wakaf';

  return '';
}

export function buildProgramFundingMap(programList = []) {
  const map = new Map();

  programList.forEach((program) => {
    const fundingMeta = resolveProgramFundingMeta(program);
    map.set(String(program?.id_program || program?.id || ''), {
      sourceType: fundingMeta.sourceType,
      sourceLabel: fundingMeta.sourceLabel,
    });
  });

  return map;
}

export function resolvePenyaluranFundingType(item, programFundingMap = new Map()) {
  const storedType = resolveStoredFundingType(item);
  if (storedType) return storedType;

  const programMeta = programFundingMap.get(String(item?.id_program || item?.program?.id_program || ''));
  return programMeta?.sourceType || '';
}

export function calculateDistributedByCategory(penyaluranList = [], programList = []) {
  const programFundingMap = buildProgramFundingMap(programList);
  const totals = new Map();

  penyaluranList.forEach((item) => {
    const key = resolvePenyaluranFundingType(item, programFundingMap);
    if (!key) return;

    totals.set(key, (totals.get(key) || 0) + (Number(item?.nominal_penyaluran) || 0));
  });

  return totals;
}

export function calculateHakAmilForSource(sourceType, amount) {
  if (sourceType === 'zakat') return Math.round(amount * 0.125);
  if (sourceType === 'infak') return Math.round(amount * 0.20);
  return 0;
}

export function applyDistributionToCategoryRows(rows = [], distributedByCategory = new Map()) {
  const remainingDistribution = new Map(distributedByCategory);

  return rows.map((row) => {
    const sourceType = row.sourceType || '';
    const hakAmil = calculateHakAmilForSource(sourceType, row.total);
    const afterHakAmil = Math.max(row.total - hakAmil, 0);
    const distributed = sourceType ? (remainingDistribution.get(sourceType) || 0) : 0;
    const used = Math.min(afterHakAmil, distributed);

    if (sourceType) {
      remainingDistribution.set(sourceType, Math.max(distributed - used, 0));
    }

    return {
      ...row,
      grossTotal: row.total,
      hakAmil,
      distributed: used,
      total: Math.max(afterHakAmil - used, 0),
    };
  });
}
